export function maskPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 11);
  const d = digits.startsWith('8') ? '7' + digits.slice(1) : digits;
  const n = d.startsWith('7') ? d : '7' + d;
  const p = n.padEnd(11, '_');
  return `+7 (${p.slice(1, 4)}) ${p.slice(4, 7)}-${p.slice(7, 9)}-${p.slice(9, 11)}`.replace(/_/g, ' ').trimEnd();
}

export function maskMoney(raw: string): string {
  const cleaned = raw.replace(/[^\d.,]/g, '').replace(',', '.');
  const parts = cleaned.split('.');
  const int = (parts[0] ?? '').replace(/^0+(\d)/, '$1').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const frac = parts[1] ? parts[1].slice(0, 2) : null;
  return frac === null ? int : `${int},${frac}`;
}

export function parseMoney(masked: string): number {
  const cleaned = masked.replace(/\s/g, '').replace(',', '.');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}

export function maskPassportSeries(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 4);
  return digits.length > 2 ? `${digits.slice(0, 2)} ${digits.slice(2)}` : digits;
}

export function maskPassportNumber(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 6);
}
